import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";
import logoIbiomed from "@/assets/logo-ibiomed.png";

export function Footer() {
  return (
    <footer className="bg-charcoal text-cream">
      <div className="container-elegant section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img 
              src={logoIbiomed} 
              alt="IBIOMED - Instituto Biomédico" 
              className="h-14 w-auto mb-4 brightness-0 invert"
              width={180}
              height={56}
            />
            <p className="text-cream/70 mb-6 max-w-md leading-relaxed">
              Instituto Biomédico Clínico e de Ensino. Referência em tratamentos 
              multidisciplinares com equipe altamente qualificada.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/institutoibiomed?igsh=MXI4c3l1eDd2OXVheQ=="
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-cream/20 flex items-center justify-center hover:bg-cream/10 transition-colors"
                aria-label="Instagram do Instituto IBIOMED"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h3 className="font-display text-lg font-medium mb-6">Navegação</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-cream/70 hover:text-cream transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/tratamentos" className="text-cream/70 hover:text-cream transition-colors">
                  Tratamentos
                </Link>
              </li>
              <li>
                <Link to="/profissionais" className="text-cream/70 hover:text-cream transition-colors">
                  Profissionais
                </Link>
              </li>
              <li>
                <Link to="/tv-ibiomed" className="text-cream/70 hover:text-cream transition-colors">
                  TV Ibiomed
                </Link>
              </li>
              <li>
                <Link to="/projeto-social" className="text-cream/70 hover:text-cream transition-colors">
                  Projeto Social
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-display text-lg font-medium mb-6">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="text-gold mt-0.5 flex-shrink-0" />
                <span className="text-cream/70 text-sm">
                  R. Natal, 118 - Boa Vista<br />
                  Novo Hamburgo - RS, 93510-020
                </span>
              </li>
              <li>
                <a
                  href="https://api.whatsapp.com/message/LVSHX74FFHBTI1?autoload=1&app_absent=0"
                  className="flex items-center gap-3 text-cream/70 hover:text-cream transition-colors"
                >
                  <Phone size={18} className="text-gold" />
                  <span className="text-sm">WhatsApp</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-cream/10 text-center">
          <p className="text-cream/50 text-sm">
            © {new Date().getFullYear()} IBIOMED - Instituto Biomédico. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
